import { useSelector } from 'react-redux';
import { getLocationPathname } from '@/redux/location/selectors';

export function usePathname(): string {
  return useSelector(getLocationPathname) as string;
}
